import type { ReactNode } from 'react'
import { useV2ProductRegulationSection } from './context'
import { regulationIsOn } from './utils'

type V2ProductRegulationSectionApplicableContentProps = {
  children: ReactNode
}

export function V2ProductRegulationSectionApplicableContent({
  children,
}: V2ProductRegulationSectionApplicableContentProps) {
  const { applicability, isLoading } = useV2ProductRegulationSection()

  if (isLoading || !regulationIsOn(applicability)) {
    return null
  }

  return <>{children}</>
}
